import * as React from "react";
import ErrorPage from "@/pages/error";

/**
 * @see https://reactjs.org/docs/error-boundaries.html
 */

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    error: null,
    errorInfo: null,
  };

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  public render() {
    const {
      state: { error, errorInfo },
      props: { children },
    } = this;
    if (error && errorInfo) {
      return (
        <>
          {process.env.NODE_ENV === "development" ? (
            <div>
              <h1>Sorry.. there was an error</h1>
              <details style={{ whiteSpace: "pre-wrap" }}>
                {error && error.toString()}
                <br />
                {errorInfo.componentStack}
              </details>
            </div>
          ) : (
            <ErrorPage />
          )}
        </>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
